import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { SharingService } from '../../../shared/shared.service';
import { Activity1, Activity2, Activity3, Activity4, Activity5 } from '../../models/Activities';
import { DeclarationService } from '../../services/forms.service';
import { from } from 'rxjs';
import { toInteger } from '@ng-bootstrap/ng-bootstrap/util/util';
import { SaveFormDeclarationLocalData } from '../../../dashboard/saveDeclarationdata';
import { DecimalPipe, CurrencyPipe, formatDate } from '@angular/common';
import { CustomSpinnerComponent } from '../../../../shared/components/custom-spinner/custom-spinner.component';
import { NumberFormatPipe } from 'src/app/shared/number.pipe';


@Component({
  selector: 'app-form5',
  templateUrl: './form5.component.html',
  styleUrls: ['./form5.component.css']
})
export class Form5Component implements OnInit {
  customSpinnerComponent = CustomSpinnerComponent;
  Form5: FormGroup;
  public activity1Model: Activity1;
  public activity2Model: Activity2;
  public activity3Model: Activity3;
  public activity4Model: Activity4;
  public activity5Model: Activity5;
  declarationList = [];
  saveFormDeclarationLocalData: SaveFormDeclarationLocalData;
  dNET: any;
  remarks: any;
  isDataEntered = false;
  percent1: number; percent2: number; percent3: number; percent4: number; percent5: number;
  Total: number = 0;
  msgMaxPercentageError: boolean = false;
  capacity: any;
  totalPercentage: number;
  msgErrorPercent: boolean = false;
  sumOfActivityNetAmt: number;
  msgErrorNET: boolean = false;
  selectedDeclarationNo : number;
  msgErrorFieldMissing: boolean = false;
  form5Data: any;
  clientsData: any;
  Year: any;
  savedForm5Data: any;
  clicked = false;
  msgErrorNotSaved: boolean = false;
  FormsData: any = [];
  today = new Date();
  jstoday = '';
  declaration5Data = {
    FormType: "",
    FormSubType: "",
    ContractNummer: "",
    AccountNumber: "",
    User: 0,
    dataXML: {
      XMLFile: {
        Header:
        {
          QualCiv: "",
          Nom: "",
          Prenom: "",
          NoClient: 0,
          RegimeLinguistique: 0,
          Email: "",
          Rue: "",
          NoRue: "",
          CodePostal: 0,
          Localite: "",
          LibellePays: ""
        },
        Declaration: [
          {
            Comment: "",
            contrat: [],
            Exercice: 0,
            PeriodeDebut: '',
            PeriodeFin: '',
            NoDeclaration: 0,
            NoProgressif: 0,
            Genre: "T",
            noIntervenantDestinataire: 0,
            NomDestinataire: "",
            PrenomDestinataire: "",
            RoleDestinataire: "",
            Statut: "",
            Libelle: "",
            CodeMontantBrut: "",
            MontantBrut: "",
            CodeMontantNet: '',
            MontantNet: 0,
            CodeMontantTVA: "",
            MontantTVA: "",
            TVAApplicable: 1,
            CodeActivite: "",
            Activite: [
              {
                TVAApplicable: 0,
                CodeActivite: "",
                Libelle: "",
                CodeMontantBrut: "",
                CodeMontantNet: "",
                CodeMontantTVA: "",
                MontantNet: 0,
                MontantTVA: 0,
                MontantBrut: "",
                CodeRepartition: "",
                Pourcent: 0
              }
            ],
            LastModifiedDate: "",
            CodePourcentTot: 0,
            independant: []
          }
        ]
      }
    }
  }
  submissionDateTime: number;
  dataXML: any;
  xmlFile: any;
  Declaration5Data: any;
  form4Data: any;
  activitiesData: any = [];
  SavedData: any;

  constructor(private _router: Router, private service: DeclarationService,
    private formBuilder: FormBuilder, public sharingService: SharingService,
    private formatPipe: NumberFormatPipe) {
    this.activity1Model = new Activity1();
  }

  ngOnInit(): void {

    this.Form5 = this.formBuilder.group({
      MNet: ['', [Validators.required,Validators.maxLength(14)]],
      remarks: ['']
    });


    //Get all the Forms data - 
    this.FormsData = JSON.parse(sessionStorage.getItem("FormsData"));
    let selectedForm = JSON.parse(sessionStorage.getItem("selectedFormData"));
    this.selectedDeclarationNo = selectedForm.NoDeclaration;

    //Get Saved Data from Cache -
    this.savedForm5Data = JSON.parse(sessionStorage.getItem("SavedDeclaration5CachedData"));

    //Get selected Clients data-
    this.clientsData = JSON.parse(sessionStorage.getItem("SelectedClientData"));

    if (sessionStorage.getItem('isForm5Saved') == 'true' && this.savedForm5Data !== null) {

      this.declaration5Data = this.savedForm5Data;
      this.dataXML = this.declaration5Data.dataXML;
      this.xmlFile = this.dataXML.XMLFile;
      var declaration = this.xmlFile.Declaration;

      declaration.forEach(element => {
        if (element.Genre == 'T' && element.NoDeclaration == this.selectedDeclarationNo) {
          this.savedForm5Data = element;
        }
      });

      this.savedForm5Data.Activite.forEach(element => {
        if (element !== null && element.CodeActivite !== '' && element.Libelle !== '') {
          this.activitiesData.push(element);
        }
      });

      this.form5Data = this.savedForm5Data;

      if (this.form5Data.Activite.length > 0) {
        this.form5Data.Libelle = this.form5Data.Activite[0].Libelle;
        //this.form5Data.MontantNet = this.form5Data.Activite[0].MontantNet;
      }
      if (this.form5Data.Activite.length > 0) {
      //Assign Declaration level NET TVA Value -
      this.form5Data.Libelle = this.form5Data.Activite[0].Libelle;
      }
      this.dNET = this.conversionDotToComma(this.form5Data.MontantNet);
      this.remarks = this.form5Data.Comment;
    }
    // Initial Load from Dashboard (Not saved data) -
    else {
      this.form5Data = JSON.parse(sessionStorage.getItem("selectedFormData"));
      var activitiesCollection = this.form5Data.Activite;
      activitiesCollection.forEach(element => {
        if (element != null && element.CodeActivite !== '' && element.Libelle !== '') {
          this.activitiesData.push(element);
        }
      });

      this.form5Data.Libelle = this.activitiesData[0].Libelle;
      this.remarks = this.form5Data.Comment;
      this.dNET = this.form5Data.MontantNet == '' || this.form5Data.MontantNet == '0' ? 0 : this.conversionDotToComma(this.form5Data.MontantNet);
      sessionStorage.setItem('isForm5Saved', "false");
    }
    if (this.activitiesData[0] !== undefined && this.activitiesData[0].CodeActivite != "") {
      this.activity1Model.ActivityNo = this.activitiesData[0].CodeActivite;
      this.activity1Model.Label = this.activitiesData[0].Libelle;
      this.activity1Model.Net = this.activitiesData[0].MontantNet == '' ? 0 : this.conversionDotToComma(this.activitiesData[0].MontantNet);

    }
  }

  formatOnFocusIn(s){
    if(s.target.value === '0' || s.target.value === '0,00'){
      s.target.value = '';
    }   

    s.target.value =  s.target.value.replace(/\./g, '');   
    s.target.value =  s.target.value.replace(/\,/g, '.');
    
    
    const commaIndex = s.target.value.indexOf(',');
    if(commaIndex >- 1){ 
    s.target.value = this.replaceAt(s.target.value,commaIndex,'.');
    }
    // const dotIndex =  s.target.value.indexOf('.');
    // if(dotIndex > -1){
    //   s.target.value  = s.target.value ;
    // }
  }

  validateOperator(s){
    var t = s.target.value;  
    
    
    if(s.keyCode === 190 || s.keyCode === 110 || s.keyCode === 46 || s.keyCode === 188 || s.keyCode === 44){//comma
     if(t.match(/[,]/g) !== null){
      if(t.match(/[,]/g).length > 1){
        return false;
      } 
     }

     if(t.match(/[.]/g) !== null){  
      if(t.match(/[.]/g).length > 1){
        return false;
      } 
     }
     
      // if(t.match(/[,]/g).length > 1 || t.match(/[.]/g).length > 1){
      //   return false;
      // } 
    }
  }



  validateDecimal(s){
    var t = s.target.value; 
    let skipCharcode = [44,46,190]; //110  : Removed 110 for Bug :54601
    const charCode = s.which ? s.which : s.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) &&  skipCharcode.indexOf(charCode) === -1) {
      return false;
    }
    //this.numberandDecimal(s);
    //dot and comma
    if(t.match(/[.]/g) !== null){
      if( t.match(/[.]/g).length > 1 || (s.keyCode === 190 || s.keyCode === 110 || s.keyCode === 46)){
        return false;
      }
      
      if(s.keyCode === 44 || s.keyCode === 188){
        return false;
      }
    }
//comma and dot
    if(t.match(/[,]/g) !== null){
      if( t.match(/[,]/g).length > 1 || (s.keyCode === 44 || s.keyCode === 188)){
        return false;
      }
      
      if(s.keyCode === 190 || s.keyCode === 110 || s.keyCode === 46){
        return false;
      }
    }

    if(s.keyCode === 190 || s.keyCode === 110 || s.keyCode === 46){
      if(t.match(/[.]/g) !== null){
        if( t.match(/[.]/g).length > 1){
          return false;
        }
      }
     
    }
    else{
      if((t.indexOf(".") > -1)){
        //s.target.value = (t.indexOf(".") >= 0) ? (t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 2)) : t;
        //s.target.value = t.split('.')[1].length < 2 ? t : t;
        if(t.split('.')[1].length < 2){
          s.target.value = t;
        }else{    
          return false;
        }
      }
      
      if((t.indexOf(",") > -1)){
        s.target.value = (t.indexOf(",") >= 0) ? 
        (t.substr(0, t.indexOf(",")) + t.substr(t.indexOf(","), 2)) :
        t;
      }
      
    }
     
    
  }

  clipboardPaste($event){
    console.log($event);
    const clipbaordData = $event.clipboardData.getData('Text');
    let s = {
      target: {
        value : clipbaordData
      }
    };

    let numericData = clipbaordData.replace(/[^0-9,.]/g, '');
   
//123,456,789=> 123456,789
//123.456.789=> 123456,789
let formatedData;
if(numericData.lastIndexOf(',') > -1){
  formatedData = numericData.substr(0,numericData.lastIndexOf(',')).replace(/\,/g,'').replace(/\./g,'') + numericData.slice(numericData.lastIndexOf(',')).replace(/\./g, '');
}else
if(numericData.lastIndexOf('.') > -1){
  formatedData = numericData.substr(0,numericData.lastIndexOf('.')).replace(/\./g,'').replace(/\,/g,'') + numericData.slice(numericData.lastIndexOf('.'));
}
  

s.target.value = formatedData;

$event.preventDefault();
 $event.target.value = formatedData.indexOf(',') > -1  ? formatedData : parseFloat(formatedData).toFixed(2);;

   

  }

  conversionDotToComma(val){
    if(typeof val === 'undefined' || val === null || val === 0)
    return val;

   // const dotIndex = val.indexOf('.');    
    return this.formatPipe.transform(val);
  }

  conversionCommaToDot(val){
    if(typeof val === 'undefined' || val === null || val === 0)
    return val;

    val =  val.toString().replace(/\./g, '');   
    val =  val.toString().replace(/\,/g, '.');    
    
    const commaIndex = val.indexOf(',');
    if(commaIndex >- 1){ 
      val = this.replaceAt(val,commaIndex,'.');
    }
    return Number(val);
  }

  formatOnFocusOut(s,modelname?){    
    if(s.target.value === ''){
      s.target.value = '0';
    }else{    
      const dotIndex = s.target.value.indexOf('.');    
      switch(modelname){
        case 'DNET':
          this.dNET =  this.formatPipe.transform(s.target.value);
          break;
        
      }
      
      s.target.value = this.formatPipe.transform(s.target.value);
    }    
  }

  replaceAt = function(val,index, replacement) {
    if (index >= val.length) {
        return val.valueOf();
    } 
    return val.substring(0, index) + replacement + val.substring(index + 1);
}

  validationandset(event: any) {
    if (this.conversionCommaToDot(this.dNET) > 999999999) {
      event.preventDefault()
      this.dNET = parseInt(this.conversionCommaToDot(this.dNET).toString().substring(0, 9));

    }
    this.isDataEntered = true;
  }
  remarksEntered() {
    if (this.remarks !== null && this.remarks !== undefined) {
      this.isDataEntered = true;
    }
  }

  //Validate & Save -
  ValidateAndSaveForm5() {
    
    this.msgErrorFieldMissing = false;
    if (this.dNET == null || this.dNET == undefined) {
      this.msgErrorFieldMissing = true;
      return false;
    }

    this.declaration5Data.dataXML.XMLFile.Declaration.forEach(element => {
      if (element.Genre == 'T') {
        element.NoDeclaration = this.selectedDeclarationNo;
      }
    });

    this.declaration5Data.dataXML.XMLFile.Declaration.forEach(element => {
      if (element.Genre == 'T'  && element.NoDeclaration == this.selectedDeclarationNo && element.Activite !== null && element.Activite.length > 0) {
        element.Activite[0].CodeActivite = this.activity1Model.ActivityNo;
        element.Activite[0].Libelle = this.activity1Model.Label;
        element.Activite[0].MontantNet = this.conversionCommaToDot(this.dNET);
        
        element.Activite[0].CodeMontantNet = 'TFACTNET';
        element.Activite[0].MontantTVA = 0;
        element.Activite[0].MontantBrut = '';
      }
    });

    this.PrepareFormRootData();
    this.PrepareHeaderData();
    this.PrepareDeclarationData();
    if (this.FormsData !== null) {
      this.FormsData.forEach(element => {
        if (element.Genre == "T" && element.NoDeclaration == this.selectedDeclarationNo) {          
          element.Libelle = element.Activite.length > 0 ? element.Activite[0].Libelle : '';
          element.MontantNet = this.conversionCommaToDot(this.dNET);
          element.MontantTVA = "0";
          element.CodeMontantNet = "TFACTTNET";
          element.CodeMontantTVA = "";
          element.Exercice = parseInt(sessionStorage.getItem("Year"));
          element.Statut = "ACTIVE";
          element.LastModifiedDate = formatDate(this.today, 'dd/MM/yyyy', 'en-US', '+0100');
          element.PeriodeDebut = element.PeriodeDebut == null ? "" : (element.PeriodeDebut.length == 10 ? element.PeriodeDebut : this.customDateFormat(element.PeriodeDebut));
          element.PeriodeFin = element.PeriodeFin == null ? "" : (element.PeriodeFin.length == 10 ? element.PeriodeFin : this.customDateFormat(element.PeriodeFin));
          element.Comment = this.remarks;
          var activite = [];
          this.declaration5Data.dataXML.XMLFile.Declaration.forEach(item => {
            if (item.Genre == 'T' && item.NoDeclaration == this.selectedDeclarationNo) {
              item.Activite.forEach(e => {
                if(activite.filter(u => u.CodeActivite === e.CodeActivite).length == 0)
                {
                  activite.push(e);
                }
              });
            }
          });
          element.Activite = activite;
        }
        else {
          this.declaration5Data.dataXML.XMLFile.Declaration.push(element);
        }
      });
    }
    this.declaration5Data.dataXML.XMLFile.Declaration = this.FormsData;
    this.SavedData = this.declaration5Data;
    var JsonForm5SaveDeclaration = JSON.stringify(this.SavedData);
    this.Declaration5Data = JSON.parse(JsonForm5SaveDeclaration);

    this.service.SaveDeclaration1(this.Declaration5Data).subscribe(
      (data) => {
        if (data == 'Failed') {
          this.msgErrorNotSaved = true;
          sessionStorage.setItem('isForm5Saved', 'false');
        }
        else {
          sessionStorage.setItem("FormsData", JSON.stringify(this.FormsData));
          sessionStorage.setItem("AllDeclarationData", JsonForm5SaveDeclaration);
          sessionStorage.setItem("SavedDeclaration5CachedData", JsonForm5SaveDeclaration);
          sessionStorage.setItem('isForm5Saved', 'true');
          sessionStorage.setItem('form5SubmittedDate', formatDate(this.today, 'dd/MM/yyyy', 'en-US', '+0100'));
          this.gotoDashboard();
        }
      },
      (err) => {
        this.msgErrorNotSaved = true;
      });
  }
  ngOnDestroy(): void {
    sessionStorage.removeItem("selectedFormData");
    this.declaration5Data.dataXML.XMLFile.Declaration = [];
  }
  gotoDashboard() {
    this._router.navigate(['/dashboard']);
  }

  PrepareDeclarationData() {
    this.declaration5Data.dataXML.XMLFile.Declaration.forEach(element => {
      if (element.Genre == 'T' && element.NoDeclaration == this.selectedDeclarationNo) {
        element.Comment = this.Form5.get("remarks").value;
        element.Genre = 'T';
        element.Exercice = parseInt(sessionStorage.getItem("Year"));
        element.noIntervenantDestinataire = this.form5Data.NoIntervenantDestinataire;
        element.RoleDestinataire = this.form5Data.RoleDestinataire;
        element.NoDeclaration = this.form5Data.NoDeclaration;
        element.NomDestinataire = this.form5Data.NomDestinataire;
        element.NoProgressif = this.form5Data.NoProgressif;

        element.RoleDestinataire = this.form5Data.RoleDestinataire;
        element.CodeMontantBrut = '';
        element.CodeMontantNet = '';
        element.CodeMontantTVA = ''
        element.MontantBrut = '';
      }
    });
  }
  customDateFormat(date) {
    if (date !== '' && date !== null) {
      if (date.length == 19) {
        var year = date.substring(0, 4);
        var month = date.substring(7, 5);
        var day = date.substring(10, 8);
        return [day ,month, year].join('/');
      } else if (date.length == 8) {
        var year = date.substring(0, 4);
        var month = date.substring(6, 4);
        var day = date.slice(date.length - 2);
        return [day ,month, year].join('/');
      } else if (date.length == 10) {
        var year = date.substring(0, 4);
        var month = date.substring(7, 5);
        var day = date.slice(date.length - 2);
        return [day ,month, year].join('/');
      } else {
        return null;
      }
    }
  }
  PrepareHeaderData() {
    this.declaration5Data.dataXML.XMLFile.Header.NoClient = parseInt(sessionStorage.getItem('ClientNo'));
    this.declaration5Data.dataXML.XMLFile.Header.Email = sessionStorage.getItem('NewEmail') != null ? sessionStorage.getItem('NewEmail') : sessionStorage.getItem('Email');
    this.declaration5Data.dataXML.XMLFile.Header.CodePostal = this.clientsData.CodePostal;
    this.declaration5Data.dataXML.XMLFile.Header.LibellePays = this.clientsData.LibellePays;
    this.declaration5Data.dataXML.XMLFile.Header.Localite = this.clientsData.Localite;
    this.declaration5Data.dataXML.XMLFile.Header.Rue = this.clientsData.Rue;
    this.declaration5Data.dataXML.XMLFile.Header.NoRue = this.clientsData.NoRue;
    this.declaration5Data.dataXML.XMLFile.Header.QualCiv = this.clientsData.QualCiv;
    this.declaration5Data.dataXML.XMLFile.Header.RegimeLinguistique = sessionStorage.getItem("currentlang") === 'FR' ? 1 : 2;
    this.declaration5Data.dataXML.XMLFile.Header.Nom = this.clientsData.Nom;
    this.declaration5Data.dataXML.XMLFile.Header.Prenom = this.clientsData.Prenom;
  }

  PrepareFormRootData() {
    this.declaration5Data.FormType = 'DECL_ON_2020';
    this.declaration5Data.FormSubType = 'FORM';
    this.declaration5Data.ContractNummer = '';
    this.declaration5Data.AccountNumber = sessionStorage.getItem('ClientNo');
    this.declaration5Data.User = 0; //yet to get from -  RetrieveDeclarationParClient
  }
  checkDataEntered() {

  }
}


